import React, { useState, useRef, useEffect } from "react";
import { useRouter } from "next/router";
import { axiosInstance } from '../../utils/axiosInstance';
import BookingDetails from "./sidebar/BookingDetails";
import CircularProgress from '@mui/material/CircularProgress';
import DiscountsPromo from "../../components/Discounts";
import PickupPoint from "../../components/PickupPoint/PickupPoint";
import PaymentModes from "../../components/PaymentModes";
import ErrorPage from "../../components/PaymentModes/error_page";
import Autocomplete from '@mui/material/Autocomplete';
import { Box, IconButton, TextField } from "@mui/material";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CancelIcon from '@mui/icons-material/Cancel';

const customTheme = createTheme({
  components: {
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: "#ffffff", // Change to your desired color
          width: "20px !important",
          height: "20px !important",
        },
      },
    },
  },
});



const countries = [
  { code: "AD", label: "Andorra", phone: "376", maxlength: "9" },
  { code: "AE", label: "United Arab Emirates", phone: "971", maxlength: "9" },
  { code: "AF", label: "Afghanistan", phone: "93", maxlength: "9" },
  { code: "AG", label: "Antigua and Barbuda", phone: "1-268", maxlength: "7" },
  { code: "AI", label: "Anguilla", phone: "1-264", maxlength: "7" },
  { code: "AL", label: "Albania", phone: "355", maxlength: "8" },
  { code: "AM", label: "Armenia", phone: "374", maxlength: "8" },
  { code: "AO", label: "Angola", phone: "244", maxlength: "9" },
  { code: "AQ", label: "Antarctica", phone: "672", maxlength: "6" },
  { code: "AR", label: "Argentina", phone: "54", maxlength: "10" },
  { code: "AS", label: "American Samoa", phone: "1-684", maxlength: "7" },
  { code: "AT", label: "Austria", phone: "43", maxlength: "10" },
  {
    code: "AU",
    label: "Australia",
    phone: "61",
    suggested: true,
    maxlength: "9",
  },
  { code: "AW", label: "Aruba", phone: "297", maxlength: "7" },
  { code: "AX", label: "Alland Islands", phone: "358", maxlength: "9" },
  { code: "AZ", label: "Azerbaijan", phone: "994", maxlength: "9" },
  { code: "BA", label: "Bosnia and Herzegovina", phone: "387", maxlength: "8" },
  { code: "BB", label: "Barbados", phone: "1-246", maxlength: "7" },
  { code: "BD", label: "Bangladesh", phone: "880", maxlength: "10" },
  { code: "BE", label: "Belgium", phone: "32", maxlength: "9" },
  { code: "BF", label: "Burkina Faso", phone: "226", maxlength: "8" },
  // Add more countries here in alphabetical order
  { code: "BG", label: "Bulgaria", phone: "359", maxlength: "9" },
  { code: "BH", label: "Bahrain", phone: "973", maxlength: "8" },
  { code: "BI", label: "Burundi", phone: "257", maxlength: "8" },
  { code: "BJ", label: "Benin", phone: "229", maxlength: "8" },
  { code: "BL", label: "Saint Barthélemy", phone: "590", maxlength: "9" },
  { code: "BM", label: "Bermuda", phone: "1-441", maxlength: "7" },
  { code: "BN", label: "Brunei Darussalam", phone: "673", maxlength: "7" },
  { code: "BO", label: "Bolivia", phone: "591", maxlength: "8" },
  { code: "BQ", label: "Bonaire", phone: "599", maxlength: "7" },
  { code: "BR", label: "Brazil", phone: "55", maxlength: "11" },
  { code: "BS", label: "Bahamas", phone: "1-242", maxlength: "7" },
  { code: "BT", label: "Bhutan", phone: "975", maxlength: "8" },
  { code: "BV", label: "Bouvet Island", phone: "", maxlength: "" },
  { code: "BW", label: "Botswana", phone: "267", maxlength: "8" },
  { code: "BY", label: "Belarus", phone: "375", maxlength: "9" },
  { code: "BZ", label: "Belize", phone: "501", maxlength: "7" },
  { code: "CA", label: "Canada", phone: "1", maxlength: "11" },
  { code: "CC", label: "Cocos Islands", phone: "61", maxlength: "9" },
  {
    code: "CD",
    label: "Democratic Republic of the Congo",
    phone: "243",
    maxlength: "9",
  },
  {
    code: "CF",
    label: "Central African Republic",
    phone: "236",
    maxlength: "8",
  },
  { code: "CG", label: "Republic of the Congo", phone: "242", maxlength: "9" },
  { code: "CH", label: "Switzerland", phone: "41", maxlength: "9" },
  { code: "CI", label: "Ivory Coast", phone: "225", maxlength: "8" },
  { code: "CK", label: "Cook Islands", phone: "682", maxlength: "5" },
  { code: "CL", label: "Chile", phone: "56", maxlength: "9" },
  { code: "CM", label: "Cameroon", phone: "237", maxlength: "8" },
  { code: "CN", label: "China", phone: "86", maxlength: "13" },
  { code: "CO", label: "Colombia", phone: "57", maxlength: "10" },
  { code: "CR", label: "Costa Rica", phone: "506", maxlength: "8" },
  { code: "CU", label: "Cuba", phone: "53", maxlength: "10" },
  { code: "CV", label: "Cape Verde", phone: "238", maxlength: "7" },
  { code: "CW", label: "Curaçao", phone: "599", maxlength: "7" },
  { code: "CX", label: "Christmas Island", phone: "61", maxlength: "9" },
  { code: "CY", label: "Cyprus", phone: "357", maxlength: "9" },
  { code: "CZ", label: "Czech Republic", phone: "420", maxlength: "9" },
  { code: "DE", label: "Germany", phone: "49", maxlength: "12" },
  { code: "DJ", label: "Djibouti", phone: "253", maxlength: "8" },
  { code: "DK", label: "Denmark", phone: "45", maxlength: "8" },
  { code: "DM", label: "Dominica", phone: "1-767", maxlength: "11" },
  { code: "DO", label: "Dominican Republic", phone: "1-809", maxlength: "11" },
  { code: "DZ", label: "Algeria", phone: "213", maxlength: "9" },
  { code: "EC", label: "Ecuador", phone: "593", maxlength: "9" },
  { code: "EE", label: "Estonia", phone: "372", maxlength: "8" },
  { code: "EG", label: "Egypt", phone: "20", maxlength: "10" },
  { code: "EH", label: "Western Sahara", phone: "212", maxlength: "9" },
  { code: "ER", label: "Eritrea", phone: "291", maxlength: "7" },
  { code: "ES", label: "Spain", phone: "34", maxlength: "9" },
  { code: "ET", label: "Ethiopia", phone: "251", maxlength: "9" },
  { code: "FI", label: "Finland", phone: "358", maxlength: "10" },
  { code: "FJ", label: "Fiji", phone: "679", maxlength: "7" },
  { code: "FK", label: "Falkland Islands", phone: "500", maxlength: "5" },
  { code: "FM", label: "Micronesia", phone: "691", maxlength: "7" },
  { code: "FO", label: "Faroe Islands", phone: "298", maxlength: "6" },
  { code: "FR", label: "France", phone: "33", maxlength: "10" },
  { code: "GA", label: "Gabon", phone: "241", maxlength: "8" },
  { code: "GB", label: "United Kingdom", phone: "44", maxlength: "11" },
  { code: "GD", label: "Grenada", phone: "1-473", maxlength: "11" },
  { code: "GE", label: "Georgia", phone: "995", maxlength: "9" },
  { code: "GF", label: "French Guiana", phone: "594", maxlength: "9" },
  { code: "GG", label: "Guernsey", phone: "44", maxlength: "10" },
  { code: "GH", label: "Ghana", phone: "233", maxlength: "9" },
  { code: "GI", label: "Gibraltar", phone: "350", maxlength: "8" },
  { code: "GL", label: "Greenland", phone: "299", maxlength: "6" },
  { code: "GM", label: "Gambia", phone: "220", maxlength: "7" },
  { code: "GN", label: "Guinea", phone: "224", maxlength: "8" },
  { code: "GP", label: "Guadeloupe", phone: "590", maxlength: "9" },
  { code: "GQ", label: "Equatorial Guinea", phone: "240", maxlength: "8" },
  { code: "GR", label: "Greece", phone: "30", maxlength: "10" },
  {
    code: "GS",
    label: "South Georgia and the South Sandwich Islands",
    phone: "",
    maxlength: "",
  },
  { code: "GT", label: "Guatemala", phone: "502", maxlength: "8" },
  { code: "GU", label: "Guam", phone: "1-671", maxlength: "11" },
  { code: "GW", label: "Guinea-Bissau", phone: "245", maxlength: "7" },
  { code: "GY", label: "Guyana", phone: "592", maxlength: "7" },
  { code: "HK", label: "Hong Kong", phone: "852", maxlength: "8" },
  {
    code: "HM",
    label: "Heard Island and McDonald Islands",
    phone: "",
    maxlength: "",
  },
  { code: "HN", label: "Honduras", phone: "504", maxlength: "8" },
  { code: "HR", label: "Croatia", phone: "385", maxlength: "9" },
  { code: "HT", label: "Haiti", phone: "509", maxlength: "8" },
  { code: "HU", label: "Hungary", phone: "36", maxlength: "9" },
  { code: "ID", label: "Indonesia", phone: "62", maxlength: "11" },
  { code: "IE", label: "Ireland", phone: "353", maxlength: "10" },
  { code: "IL", label: "Israel", phone: "972", maxlength: "9" },
  { code: "IM", label: "Isle of Man", phone: "44", maxlength: "10" },
  { code: "IN", label: "India", phone: "91", maxlength: "10" },
  {
    code: "IO",
    label: "British Indian Ocean Territory",
    phone: "246",
    maxlength: "7",
  },
  { code: "IQ", label: "Iraq", phone: "964", maxlength: "10" },
  { code: "IR", label: "Iran", phone: "98", maxlength: "11" },
  { code: "IS", label: "Iceland", phone: "354", maxlength: "7" },
  { code: "IT", label: "Italy", phone: "39", maxlength: "11" },
  { code: "JE", label: "Jersey", phone: "44", maxlength: "10" },
  { code: "JM", label: "Jamaica", phone: "1-876", maxlength: "11" },
  { code: "JO", label: "Jordan", phone: "962", maxlength: "9" },
  { code: "JP", label: "Japan", phone: "81", maxlength: "11" },
  { code: "KE", label: "Kenya", phone: "254", maxlength: "10" },
  { code: "KG", label: "Kyrgyzstan", phone: "996", maxlength: "9" },
  { code: "KH", label: "Cambodia", phone: "855", maxlength: "9" },
  { code: "KI", label: "Kiribati", phone: "686", maxlength: "5" },
  { code: "KM", label: "Comoros", phone: "269", maxlength: "7" },
  {
    code: "KN",
    label: "Saint Kitts and Nevis",
    phone: "1-869",
    maxlength: "11",
  },
  { code: "KP", label: "North Korea", phone: "850", maxlength: "10" },
  { code: "KR", label: "South Korea", phone: "82", maxlength: "10" },
  { code: "KW", label: "Kuwait", phone: "965", maxlength: "8" },
  { code: "KY", label: "Cayman Islands", phone: "1-345", maxlength: "11" },
  { code: "KZ", label: "Kazakhstan", phone: "7", maxlength: "11" },
  { code: "LA", label: "Laos", phone: "856", maxlength: "8" },
  { code: "LB", label: "Lebanon", phone: "961", maxlength: "8" },
  { code: "LC", label: "Saint Lucia", phone: "1-758", maxlength: "11" },
  { code: "LI", label: "Liechtenstein", phone: "423", maxlength: "9" },
  { code: "LK", label: "Sri Lanka", phone: "94", maxlength: "10" },
  { code: "LR", label: "Liberia", phone: "231", maxlength: "7" },
  { code: "LS", label: "Lesotho", phone: "266", maxlength: "8" },
  { code: "LT", label: "Lithuania", phone: "370", maxlength: "8" },
  { code: "LU", label: "Luxembourg", phone: "352", maxlength: "9" },
  { code: "LV", label: "Latvia", phone: "371", maxlength: "8" },
  { code: "LY", label: "Libya", phone: "218", maxlength: "9" },
  { code: "MA", label: "Morocco", phone: "212", maxlength: "9" },
  { code: "MC", label: "Monaco", phone: "377", maxlength: "9" },
  { code: "MD", label: "Moldova", phone: "373", maxlength: "8" },
  { code: "ME", label: "Montenegro", phone: "382", maxlength: "8" },
  { code: "MF", label: "Saint Martin", phone: "590", maxlength: "9" },
  { code: "MG", label: "Madagascar", phone: "261", maxlength: "9" },
  { code: "MH", label: "Marshall Islands", phone: "692", maxlength: "7" },
  { code: "MK", label: "North Macedonia", phone: "389", maxlength: "8" },
  { code: "ML", label: "Mali", phone: "223", maxlength: "8" },
  { code: "MM", label: "Myanmar", phone: "95", maxlength: "9" },
  { code: "MN", label: "Mongolia", phone: "976", maxlength: "8" },
  { code: "MO", label: "Macao", phone: "853", maxlength: "8" },
  {
    code: "MP",
    label: "Northern Mariana Islands",
    phone: "1-670",
    maxlength: "11",
  },
  { code: "MQ", label: "Martinique", phone: "596", maxlength: "9" },
  { code: "MR", label: "Mauritania", phone: "222", maxlength: "8" },
  { code: "MS", label: "Montserrat", phone: "1-664", maxlength: "11" },
  { code: "MT", label: "Malta", phone: "356", maxlength: "8" },
  { code: "MU", label: "Mauritius", phone: "230", maxlength: "7" },
  { code: "MV", label: "Maldives", phone: "960", maxlength: "7" },
  { code: "MW", label: "Malawi", phone: "265", maxlength: "9" },
  { code: "MX", label: "Mexico", phone: "52", maxlength: "13" },
  { code: "MY", label: "Malaysia", phone: "60", maxlength: "10" },
  { code: "MZ", label: "Mozambique", phone: "258", maxlength: "9" },
  { code: "NA", label: "Namibia", phone: "264", maxlength: "9" },
  { code: "NC", label: "New Caledonia", phone: "687", maxlength: "6" },
  { code: "NE", label: "Niger", phone: "227", maxlength: "8" },
  { code: "NF", label: "Norfolk Island", phone: "672", maxlength: "6" },
  { code: "NG", label: "Nigeria", phone: "234", maxlength: "10" },
  { code: "NI", label: "Nicaragua", phone: "505", maxlength: "8" },
  { code: "NL", label: "Netherlands", phone: "31", maxlength: "10" },
  { code: "NO", label: "Norway", phone: "47", maxlength: "8" },
  { code: "NP", label: "Nepal", phone: "977", maxlength: "10" },
  { code: "NR", label: "Nauru", phone: "674", maxlength: "7" },
  { code: "NU", label: "Niue", phone: "683", maxlength: "4" },
  { code: "NZ", label: "New Zealand", phone: "64", maxlength: "10" },
  { code: "OM", label: "Oman", phone: "968", maxlength: "8" },
  { code: "PA", label: "Panama", phone: "507", maxlength: "8" },
  { code: "PE", label: "Peru", phone: "51", maxlength: "9" },
  { code: "PF", label: "French Polynesia", phone: "689", maxlength: "6" },
  { code: "PG", label: "Papua New Guinea", phone: "675", maxlength: "7" },
  { code: "PH", label: "Philippines", phone: "63", maxlength: "10" },
  { code: "PK", label: "Pakistan", phone: "92", maxlength: "10" },
  { code: "PL", label: "Poland", phone: "48", maxlength: "9" },
  {
    code: "PM",
    label: "Saint Pierre and Miquelon",
    phone: "508",
    maxlength: "6",
  },
  { code: "PN", label: "Pitcairn", phone: "870", maxlength: "15" },
  { code: "PR", label: "Puerto Rico", phone: "1", maxlength: "11" },
  { code: "PS", label: "Palestinian Territory", phone: "970", maxlength: "10" },
  { code: "PT", label: "Portugal", phone: "351", maxlength: "9" },
  { code: "PW", label: "Palau", phone: "680", maxlength: "7" },
  { code: "PY", label: "Paraguay", phone: "595", maxlength: "9" },
  { code: "QA", label: "Qatar", phone: "974", maxlength: "8" },
  { code: "RE", label: "Réunion", phone: "262", maxlength: "9" },
  { code: "RO", label: "Romania", phone: "40", maxlength: "10" },
  { code: "RS", label: "Serbia", phone: "381", maxlength: "10" },
  { code: "RU", label: "Russia", phone: "7", maxlength: "11" },
  { code: "RW", label: "Rwanda", phone: "250", maxlength: "9" },
  { code: "SA", label: "Saudi Arabia", phone: "966", maxlength: "9" },
  { code: "SB", label: "Solomon Islands", phone: "677", maxlength: "5" },
  { code: "SC", label: "Seychelles", phone: "248", maxlength: "7" },
  { code: "SD", label: "Sudan", phone: "249", maxlength: "9" },
  { code: "SE", label: "Sweden", phone: "46", maxlength: "11" },
  { code: "SG", label: "Singapore", phone: "65", maxlength: "8" },
  { code: "SH", label: "Saint Helena", phone: "290", maxlength: "4" },
  { code: "SI", label: "Slovenia", phone: "386", maxlength: "8" },
  { code: "SJ", label: "Svalbard and Jan Mayen", phone: "47", maxlength: "8" },
  { code: "SK", label: "Slovakia", phone: "421", maxlength: "9" },
  { code: "SL", label: "Sierra Leone", phone: "232", maxlength: "8" },
  { code: "SM", label: "San Marino", phone: "378", maxlength: "10" },
  { code: "SN", label: "Senegal", phone: "221", maxlength: "9" },
  { code: "SO", label: "Somalia", phone: "252", maxlength: "7" },
  { code: "SR", label: "Suriname", phone: "597", maxlength: "7" },
  { code: "SS", label: "South Sudan", phone: "211", maxlength: "9" },
  { code: "ST", label: "Sao Tome and Principe", phone: "239", maxlength: "7" },
  { code: "SV", label: "El Salvador", phone: "503", maxlength: "8" },
  { code: "SX", label: "Sint Maarten", phone: "1-721", maxlength: "11" },
  { code: "SY", label: "Syria", phone: "963", maxlength: "9" },
  { code: "SZ", label: "Eswatini", phone: "268", maxlength: "8" },
  {
    code: "TC",
    label: "Turks and Caicos Islands",
    phone: "1-649",
    maxlength: "11",
  },
  { code: "TD", label: "Chad", phone: "235", maxlength: "8" },
  {
    code: "TF",
    label: "French Southern Territories",
    phone: "",
    maxlength: "",
  },
  { code: "TG", label: "Togo", phone: "228", maxlength: "8" },
  { code: "TH", label: "Thailand", phone: "66", maxlength: "10" },
  { code: "TJ", label: "Tajikistan", phone: "992", maxlength: "9" },
  { code: "TK", label: "Tokelau", phone: "690", maxlength: "4" },
  { code: "TL", label: "East Timor", phone: "670", maxlength: "7" },
  { code: "TM", label: "Turkmenistan", phone: "993", maxlength: "8" },
  { code: "TN", label: "Tunisia", phone: "216", maxlength: "8" },
  { code: "TO", label: "Tonga", phone: "676", maxlength: "5" },
  { code: "TR", label: "Turkey", phone: "90", maxlength: "11" },
  { code: "TT", label: "Trinidad and Tobago", phone: "1-868", maxlength: "11" },
  { code: "TV", label: "Tuvalu", phone: "688", maxlength: "5" },
  { code: "TW", label: "Taiwan", phone: "886", maxlength: "10" },
  { code: "TZ", label: "Tanzania", phone: "255", maxlength: "10" },
  { code: "UA", label: "Ukraine", phone: "380", maxlength: "12" },
  { code: "UG", label: "Uganda", phone: "256", maxlength: "9" },
  {
    code: "UM",
    label: "United States Minor Outlying Islands",
    phone: "",
    maxlength: "",
  },
  { code: "US", label: "United States", phone: "1", maxlength: "11" },
  { code: "UY", label: "Uruguay", phone: "598", maxlength: "8" },
  { code: "UZ", label: "Uzbekistan", phone: "998", maxlength: "9" },
  { code: "VA", label: "Vatican", phone: "379", maxlength: "10" },
  {
    code: "VC",
    label: "Saint Vincent and the Grenadines",
    phone: "1-784",
    maxlength: "11",
  },
  { code: "VE", label: "Venezuela", phone: "58", maxlength: "10" },
  {
    code: "VG",
    label: "British Virgin Islands",
    phone: "1-284",
    maxlength: "11",
  },
  { code: "VI", label: "U.S. Virgin Islands", phone: "1-340", maxlength: "11" },
  { code: "VN", label: "Vietnam", phone: "84", maxlength: "10" },
  { code: "VU", label: "Vanuatu", phone: "678", maxlength: "5" },
  { code: "WF", label: "Wallis and Futuna", phone: "681", maxlength: "6" },
  { code: "WS", label: "Samoa", phone: "685", maxlength: "5" },
  { code: "YE", label: "Yemen", phone: "967", maxlength: "9" },
  { code: "YT", label: "Mayotte", phone: "262", maxlength: "9" },
  { code: "ZA", label: "South Africa", phone: "27", maxlength: "11" },
  { code: "ZM", label: "Zambia", phone: "260", maxlength: "9" },
  { code: "ZW", label: "Zimbabwe", phone: "263", maxlength: "9" },
];

function countryToFlag(isoCode) {
  return typeof String.fromCodePoint !== "undefined"
    ? isoCode
      .toUpperCase()
      .replace(/./g, (char) =>
        String.fromCodePoint(char.charCodeAt(0) + 127397)
      )
    : isoCode;
}

const CustomerInfo = ({
  setFormLoading,
  formLoading,
  searchCountryCodeValue,
  setSearchCountryCodeValue,
  bookingRes,
  setBookingLoader,
  setGetDetails,
  getDetails,
  setValues,
  bookingLoader,
  values,
  handleSubmitting,
  price,
  discountAmount,
  extraCharge,
  vendorId,
  currency,
  packageId,
  vat,
  withPickup,
  pickupPoints,
  setPickupPoints,
  originalPrice,
  optionType,
  group,
  groupAmt,
  groupOriginalAmt,
  adult,
  child,
  senior,
  adultAmt,
  childAmt,
  seniorAmt, errorMessage, setErrorMessage,
  totalPay,
  setTotalPay, activityId
}) => {
  const router = useRouter();

  const apiKey = process.env.MAPKEY;
  const ref0 = useRef();
  const [pickup, setPickup] = useState("");


  const [defaultCode, setDefaultCode] = useState({
    code: "AE",
    label: "United Arab Emirates",
    phone: "971",
    maxlength: "9",
  });
  const [click, setClick] = useState(false);
  const [open, setOpen] = useState(false);
  const [validate, setValidate] = useState(false);
  const [formLoad, setFormLoad] = useState(true);
  const [isBookNow, setIsBookNow] = useState(false);
  const [code, setCode] = useState("");
  const userId = JSON.parse(sessionStorage.getItem("rslkey"));


  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const regex = /^[a-zA-Z\s]*$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (name === "phone") {
      const phoneNumber = value.replace(/[^0-9]/g, "");
      // Check if the length exceeds the maximum allowed length
      if (
        phoneNumber.length > (defaultCode ? defaultCode.maxlength : Infinity)
      ) {
        return;
      }
      // Update the state with the cleaned phone number
      setValues({ ...values, [name]: phoneNumber });
    } else {
      if (!regex.test(value)) {
        if (name !== "email") {
          return;
        }
      }
      setValues({ ...values, [name]: value });

      if (name === "email") {
        setErrors((prevErrors) => ({
          ...prevErrors,
          error: validateEmail(value) ? "" : "Invalid email format",
        }));
      }

    }
    setValidate(false);
  };

  const currentPath = router.asPath;
  const handleCurrency = () => {
    setClick((prevState) => !prevState);
    // router.push("/sign-in/sign-in");
    sessionStorage.setItem("bookingPath", currentPath);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setFormLoad(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  function handleBooking(index, car) {
    if (JSON.parse(sessionStorage.getItem("rslkey")) !== null) {
      //
    } else {
      handleCurrency();
    }
  }
  function areAllValuesEmpty(obj) {
    return Object.entries(obj).every(([key, value]) => {
      if (key === "specialRequest") {
        return true;
      }
      return Boolean(value);
    });
  }
  const [errors, setErrors] = useState({
    name: "",
    email: "",
    phone: "",
    specialRequest: "",
  });

  const [validationErrors, setValidationErrors] = useState({});

  const isValidEmail = (email) => {
    // Regular expression pattern for basic email validation
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(String(email).toLowerCase());
  };

  const handleValidation = () => {
    const newErrors = {};
    if (!values.name) {
      newErrors.name = "Please enter your full name *";
    } else if (values.name.length < 3) {
      newErrors.name = "Your name should be at least 3 characters long.";
    } else if (values.name.length > 20) {
      newErrors.name = "Your name should not exceed 20 characters.";
    }

    if (!values.email) {
      newErrors.email = "Please enter your email address *";
    } else if (!values.email.includes("@")) {
      newErrors.email = "Oops! Your email must contain '@'.";
    } else if (!isValidEmail(values?.email)) {
      newErrors.email = "Please enter a valid email address (e.g., example@mail.com).";
    }

    if (!values.phone) {
      newErrors.phone = "Please enter your phone number *";
    } else if (/^0+$/.test(values.phone)) {
      newErrors.phone = "Oops! That doesn't look like a valid phone number.";
    }

    if (!values.countryCode) {
      newErrors.countryCode = "Please select your country code *";
    }
    // if (!values.specialRequest) {
    //   newErrors.specialRequest = 'Required *';
    // }
    return newErrors;
  };

  const handlePayment = () => {
    const userId = JSON.parse(sessionStorage.getItem("rslkey"));
    const userEmailStored = sessionStorage.getItem("userEmail");

    const newErrors = handleValidation();

    // Check if discountAmount fully covers the price (bypass payment)
    const skipPayment = discountAmount !== 0 && discountAmount !== '' && discountAmount !== undefined ? Number(discountAmount) === Number(price) : "";


    if (Object.keys(newErrors).length === 0) {
      setIsBookNow(true);

      if (userId !== null) {
        if (areAllValuesEmpty(values)) {
          // If userEmail is stored, open the modal
          if (userEmailStored !== null) {
            if (skipPayment) {
              setIsBookNow(true);
              handleSubmitting(); // Proceed without payment
            } else {
              setOpen(true);
              setIsBookNow(false);
            }
          } else {
            setValidate(false);
          }
        } else {
          setValidate(true);
        }
      } else {
        if (areAllValuesEmpty(values)) {
          setIsBookNow(true);
          handleSubmitting();
        } else {
          setValidate(false);
        }
      }
    } else {
      setValidate(true);
      setErrors(newErrors);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setBookingLoader(false);
    setErrorMessage(null);
  };

  const handleCardOption = (data) => {
    handleSubmitting(data);
  };

  useEffect(() => {
    if (searchCountryCodeValue !== "" && searchCountryCodeValue !== undefined) {
      var removePlus = searchCountryCodeValue?.replace("+", "");
      var filterCountry = countries.filter(
        (data) => data.phone == JSON.parse(removePlus)
      );
      setValues({
        ...values,
        ["countryCode"]: searchCountryCodeValue.includes("+")
          ? searchCountryCodeValue
          : `+${searchCountryCodeValue}`,
      });

      setDefaultCode(filterCountry[0]);
      setFormLoading(false);
    }
  }, [searchCountryCodeValue]);

  const componentDidMountPickup = async () => {
    const response = await axiosInstance.get(
      `${process.env.BACKEND_URL}/location/geocode?address=${pickup}`
    )

    // const response = await axios.get(
    //   `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
    //     pickup
    //   )}&key=${apiKey}`
    // );

    const { results } = response.data;
    if (results && results.length > 0) {
      const { lat, lng } = results[0].geometry.location;
      setPickupPoints({
        address: pickup,
        lat: lat ? lat : 0,
        lng: lng ? lng : 0,
      });
    } else {
      setPickupPoints({
        address: "",
        lat: "",
        lng: "",
      });
    }
  };

  useEffect(() => {
    if (pickup && pickup !== "") {
      componentDidMountPickup();
    }
  }, [pickup]);

  return (
    <>
      <Box
        className="col-xl-7 col-lg-8 mt-30"
        sx={{
          "& .MuiInputBase-root": {
            "&:before": {
              borderBottom: "transparent",
            },
            "&:hover": {
              borderBottom: "transparent",
            },
          },
        }}
      >

        {formLoading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              height: "300px",
              alignItems: "center",
            }}
          >
            <CircularProgress
              style={{
                color: "green",
                width: "50px",
                height: "50px",
              }}
            />
          </Box>
        ) : (
          <div className="row x-gap-20 y-gap-20">
            <div className="col-12">
              <div className="form-input ">
                <input
                  type="text"
                  name="name"
                  value={values.name}
                  required
                  onChange={handleChange}
                  maxLength={50}
                />
                <label className="lh-1 text-16 text-light-1">
                  Full Name <span style={{ color: '#DC3545' }}>*</span>
                </label>
              </div>
              {errors.name ? (
                <p
                  style={{
                    color: validate ? '#DC3545' : "white",
                  }}
                >
                  {errors.name}
                </p>
              ) : (
                ""
              )}
            </div>
            {/* End col-12 */}

            <div className="col-md-6">
              <div className="form-input ">
                <input
                  type="email"
                  required
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}"
                  title="Please enter a valid email address."
                />

                <label className="lh-1 text-16 text-light-1">
                  Email <span style={{ color: '#DC3545' }}>*</span>
                </label>
              </div>
              {errors.email ? (
                <p
                  style={{
                    color: validate ? '#DC3545' : "white",
                  }}
                >
                  {errors.email}
                </p>
              ) : (
                ""
              )}
            </div>
            {/* End col-12 */}

            <div className="col-md-6">
              <div className="row x-gap-0 border">
                <div className="col-3">
                  <div className="">
                    <label className="lh-1 text-16 text-light-1 px-2">Code</label>
                    <div className="">
                      <Autocomplete
                        defaultValue={defaultCode}
                        name="countryCode"
                        ref={ref0}
                        onChange={(e, newValue) => setSearchCountryCodeValue(newValue.phone)}
                        freeSolo
                        disableClearable
                        options={countries}
                        autoHighlight
                        getOptionLabel={(option) => `${option.code}+${option.phone}`}
                        filterOptions={(options, { inputValue }) =>
                          options.filter(
                            (option) =>
                              option.label.toLowerCase().includes(inputValue.toLowerCase()) ||
                              option.code.toLowerCase().includes(inputValue.toLowerCase()) ||
                              option.phone.includes(inputValue)
                          )
                        }
                        renderOption={(props, option) => (
                          <li {...props}>
                            {option.label} ({option.code}) +{option.phone}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name="code"
                            size="small"
                            placeholder="AE+971"
                            required
                            onClick={(params) => (params.target.value = "")}
                            variant="standard"
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: "new-password",
                            }}
                          />
                        )}
                        sx={{
                          width: "100%",
                          "& .MuiAutocomplete-option": {
                            // same as classes.option
                            // backgroundColor: "green",
                          },
                          "& .MuiAutocomplete-paper": {
                            // same as classes.paper
                            width: "300px",
                          },
                          "& .MuiAutocomplete-inputRoot": {
                            // same as classes.inputRoot
                            borderTopRightRadius: "0px",
                            borderBottomRightRadius: "0px",
                            border: "none",
                            paddingLeft: "12px",
                          },
                          "& .MuiAutocomplete-input": {
                            // same as classes.input
                            // fontSize: "14px",
                          },
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-9 vertical-divider">
                  <div className="form-input ">
                    <input
                      type="text"
                      required
                      name="phone"
                      maxLength={
                        defaultCode ? defaultCode.maxlength : undefined
                      }
                      value={values.phone}
                      onChange={handleChange}
                      onInput={(e) =>
                      (e.target.value = e.target.value
                        .replace(/[^0-9.]/g, "")
                        .replace(/(\..*)\./g, "$1"))
                      }
                      style={{
                        border: "none"
                      }}
                    />
                    <label className="lh-1 text-16 text-light-1">
                      Phone Number <span style={{ color: '#DC3545' }}>*</span>
                    </label>
                  </div>
                </div>
              </div>
              {errors.phone ? (
                <p
                  style={{
                    color: validate ? '#DC3545' : "white",
                  }}
                >
                  {errors.phone}
                </p>
              ) : (
                ""
              )}
            </div>

            <div className="col-12">
              <div className="form-input ">
                <textarea
                  name="specialRequest"
                  value={values.specialRequest}
                  onChange={handleChange}
                  rows={3}
                  defaultValue={""}
                  maxLength={250}
                />
                <label className="lh-1 text-16 text-light-1 bg-white">
                  Special Requests
                </label>
              </div>
              {errors.specialRequest ? (
                <p
                  style={{
                    color: validate ? '#DC3545' : "white",
                  }}
                >
                  {errors.specialRequest}
                </p>
              ) : (
                ""
              )}
            </div>
            {/* End col-12 */}

            {withPickup === "true" && (
              <div className="col-12">
                <PickupPoint
                  serviceId={4}
                  type={"pickup"}
                  pickup={pickup}
                  label="Pickup Location"
                  placeholder="Search"
                  setPickup={(mPickUp) => {
                    setPickup(mPickUp);
                  }}
                  activityId={activityId}
                />
              </div>
            )}

            {userId !== null && (
              <div className="col-12">
                <DiscountsPromo
                  serviceId={6}
                  setCode={setCode}
                  code={code}
                  setGetDetails={setGetDetails}
                  getDetails={getDetails}
                  vendorId={vendorId}
                  price={price}
                  packageId={packageId}
                  adultCount={adult}
                  childCount={child}
                  seniorCount={senior}
                  adultAmt={adultAmt}
                  childAmt={childAmt}
                  seniorAmt={seniorAmt}
                />
              </div>
            )}

            <div className="col-12">
              <div className="row y-gap-20 items-center justify-between">
                <div className="col-auto">
                  <div className="text-14 text-light-1">
                    By proceeding with this booking, I agree to
                    Royalsmartlifestyle {""}
                    <a
                      style={{
                        color: "lightblue",
                        fontWeight: "bold",
                      }}
                      href={`${process.env.NEXTAUTH_URL}/termsAndConditions/Activity`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Terms of Use and Privacy Policy.
                    </a>
                  </div>
                </div>
                {/* End col-12 */}
              </div>
            </div>
            <div className="col-12 justify-center d-flex">
              <div className="row y-gap-20 items-center justify-between">
                <div className="text-14 text-light-1">
                  {validate ? (
                    <p
                      style={{
                        color: validate ? '#DC3545' : "white",
                      }}
                    >
                      Please fill all the fields
                    </p>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            {/* End col-12 */}

            <div className="col-12 justify-center d-flex">
              <div style={{
                width: "50%"
              }}>
                <ThemeProvider theme={customTheme}>
                  <button
                    type="button"
                    className="mainSearch__submit btn-1 button -dark-4 py-15 px-15  bg-dark-3 text-white w-75"
                    onClick={() => handlePayment()}
                  >
                    {isBookNow ? <CircularProgress /> : "Book Now"}
                  </button>
                </ThemeProvider>
              </div>
            </div>

            {/* <div className="col-12 justify-center d-flex">
              <ThemeProvider theme={customTheme}>
                <button
                  type="button"
                  onClick={() => handlePayment()}
                  className="button h-50 px-24 text-white -dark-4 px-20 bg-dark-3 text-white"
                >
                  {isBookNow ? <CircularProgress /> : "Book Now"}
                </button>
              </ThemeProvider>
            </div> */}
          </div>
        )}
        {/* End .row */}
      </Box>
      {/* End .col-xl-7 */}

      <div className="col-xl-5 col-lg-4 mt-30">
        <div className="booking-sidebar">
          <BookingDetails
            getDetails={getDetails}
            price={price}
            originalPrice={originalPrice}
            extraCharge={extraCharge}
            vat={vat}
            currency={currency}
            optionType={optionType}
            group={group}
            groupAmt={groupAmt}
            groupOriginalAmt={groupOriginalAmt}
            totalPay={totalPay}
            setTotalPay={setTotalPay}
          />
        </div>
      </div>
      <Dialog
        fullWidth={true}
        className="text-center"
        keepMounted
        maxWidth="md"
        //  maxWidth={maxWidth}
        open={open}
        // onClose={handleCloseBookNow}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"

      >
        <DialogActions className="mt-5 mb-5 items-center justify-between d-flex">
          {/* <button className="text-white" onClick={handleClose} autoFocus>
            Okay
          </button> */}
          {/* close */}
          <IconButton onClick={handleClose} sx={{ position: "absolute", top: 8, right: 8 }}>
            <CancelIcon />
          </IconButton>
          {
            errorMessage && errorMessage?.status !== 1 ? "" :
              <Typography
                className="fw-bold jura"
                variant="h6"
                sx={{
                  fontSize: { xs: "16px", sm: "18px", md: "20px", lg: "24px" }, // Adjust for different screen sizes
                  justifyContent: "center !important",
                  textAlign: "center"
                }}
              >
                How would you like to pay?
              </Typography>
          }


          {/* <CancelIcon
            onClick={handleClose}
            style={{
              color: "#6b6b6b",
              cursor: "pointer",
              fontSize: "26px",
            }}
          /> */}
        </DialogActions>
        {
          errorMessage && errorMessage?.status !== 1 ? "" :
            <hr style={{
              margin: '0px'
            }} />
        }



        {
          errorMessage && errorMessage?.status !== 1 ?
            <ErrorPage handleClose={handleClose} errorMessage={errorMessage} /> :
            <PaymentModes
              bookingRes={bookingRes}
              bookingLoader={bookingLoader}
              handleCardOption={handleCardOption}
              getDetails={getDetails}
              vat={vat}
              price={price}
              setBookingLoader={setBookingLoader}
              handleClose={handleClose}
              errorMessage={errorMessage}
              setErrorMessage={setErrorMessage}
            />
        }

      </Dialog>
      {/*  */}

      <div
        className={`currencyMenu js-currencyMenu ${click ? "" : "is-hidden"}`}
      >
        <div className="currencyMenu__bg" onClick={handleCurrency}></div>
        <div className="currencyMenu__signpop bg-white rounded-4">
          <div className="d-flex items-center justify-between px-30 py-20 sm:px-15 border-bottom-light">
            {/* End Title */}
            <div />

            <button className="pointer" onClick={handleCurrency}>
              <i className="icon-close" />
            </button>
            {/* End colse button */}
          </div>
          {/* End flex wrapper */}
          <div
            className="text-20 fw-500 lh-15 px-30  py-30 sm:px-15 sm:py-15"
            style={{
              textAlign: "center",
            }}
          >
            To continue Booking, please sign in to your account
          </div>
          <div
            className="px-30  py-30 sm:px-15 sm:py-15"
            style={{
              textAlign: "center",
            }}
          >
            {/* {currencyContent.map((item) => (
              <li
                className={`modalGrid__item js-item ${
                  selectedCurrency.currency === item.currency ? "active" : ""
                }`}
                key={item.id}
                onClick={() => handleItemClick(item)}
              >
                <div className="py-10 px-15 sm:px-5 sm:py-5">
                  <div className="text-15 lh-15 fw-500 text-dark-1">
                    {item.name}
                  </div>
                  <div className="text-14 lh-15 mt-5">
                    <span className="js-title">{item.currency}</span>-{" "}
                    {item.symbol}
                  </div>
                </div>
              </li>
            ))} */}

            <button
              className="btn bg-dark-3 text-white"
              onClick={() => {
                // router.push("/sign-in/sign-in");
                sessionStorage.setItem("isSig", true);
                setClick(false);
              }}
            >
              Sign In
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerInfo;
